import { render, staticRenderFns } from "./message-list.vue?vue&type=template&id=6f79f5a2&scoped=true&"
import script from "./message-list.vue?vue&type=script&lang=ts&"
export * from "./message-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f79f5a2",
  null
  
)

export default component.exports